import React, { useState, useMemo, useCallback, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  IconButton
} from "@mui/material";

import { ReactComponent as CloseIcon } from "assets/img/svg/CrossIcon.svg";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { EMPTY_GENERATE_REPORT_FORM } from "./constant";
import moment from "moment";

const BUSINESS_TYPES = {
  FRANCHISE: "Franchise",
  SUB_CONTRACTOR: "SubContractor",
  SINGLE: "SINGLE"
};

const SUBTYPE_CONFIG = {
  [BUSINESS_TYPES.FRANCHISE]: [
    { label: "ALC", value: "ALC" },
    { label: "F+EC", value: "F+EC" },
    { label: "Pure Franchise", value: "NONE" }
  ],
  [BUSINESS_TYPES.SUB_CONTRACTOR]: [
    { label: "ALC", value: "ALC" },
    { label: "F+EC", value: "F+EC" },
    { label: "Pure Flip", value: "NONE" }
  ]
};

export const subTypeMapping = {
  ALC: 'ALC',
  "F+EC": 'FEC',
  "NONE": 'NONE'
}


const GenerateCommissionDialog = ({ open, onClose, dropdownData, generateCommissionReport, isBulkAccess, isCreateAccess }) => {
  const [form, setForm] = useState(EMPTY_GENERATE_REPORT_FORM);

  const [loadingAreas, setLoadingAreas] = useState(false);

  const { businessUnitType = [], businessAreas = [] } = dropdownData || {};

  const subtypeOptions = useMemo(() => {
    return SUBTYPE_CONFIG[form.businessType?.label] || [];
  }, [form.businessType]);

  const updateForm = useCallback((key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleBusinessTypeChange = useCallback(
    (event) => {
      const selectedValue = event.target.value;

      let selectedObj =
        selectedValue === BUSINESS_TYPES.SINGLE
          ? { label: selectedValue, value: selectedValue }
          : businessUnitType.find((item) => item.label === selectedValue);

      setForm((prev) => ({
        ...prev,
        businessType: selectedObj || null,
        subtype: "",
        businessArea: []
      }));
    },
    [businessUnitType]
  );

  const handleSubtypeChange = useCallback((event) => {
    const value = event.target.value;
    setForm((prev) => ({ ...prev, subtype: value, businessArea: [] }));
  }, []);

  const fetchBusinessAreas = (businessTypeObj, subtype) => {
    try {
      setLoadingAreas(true);

      const filtered = businessAreas.filter(
        (item) =>
          item.businessUnitTypeId?.[0] === businessTypeObj?.value &&
          (item.franchiseSubType).toUpperCase() == subtype
      );

      updateForm("businessArea", filtered);
    } catch (error) {
      console.error("Error fetching business areas:", error);
    } finally {
      setLoadingAreas(false);
    }
  };

  useEffect(() => {
    if (
      form.businessType &&
      form.subtype &&
      form.businessType.value !== BUSINESS_TYPES.SINGLE
    ) {
      fetchBusinessAreas(form.businessType, form.subtype);
    }
  }, [form.businessType, form.subtype]);

  const isGenerateDisabled = useMemo(() => {
    const { startDate, endDate, businessType, subtype, businessArea } = form;

    if (!startDate || !endDate || !businessType) return true;

    if (businessType?.value === BUSINESS_TYPES.SINGLE) {
      return !businessArea.length;
    }

    return !subtype || !businessArea.length;
  }, [form]);

  const buildPayload = () => {
    debugger
    const { businessType, subtype, businessArea, startDate, endDate } = form;
    console.log(businessArea,form,'businessArea')
    const resolveSubType = () => {
      debugger
      if (businessType?.value === BUSINESS_TYPES.SINGLE) {
        const subType = businessArea?.[0]?.franchiseSubType;

        if (!subType || typeof subType !== "string") {
          return null; // fallback
        }

        return subTypeMapping?.[subType.toUpperCase()] || subType;
      }

      return subTypeMapping?.[subtype] || subtype;   // "ALC" or "F+EC" → sent as-is
    };

    return {
      startDate: moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      businessAreaType: businessType?.label===BUSINESS_TYPES.SINGLE ? (businessUnitType?.find(item=>item?.value==businessArea[0]?.businessUnitTypeId?.[0]))?.label : businessType?.label,
      singleBusinessAreaType: businessType?.value === BUSINESS_TYPES.SINGLE?BUSINESS_TYPES.SINGLE : null,
      subType: resolveSubType(),
      businessAreas: businessArea.map((item) => ({
        businessArea: item.label,
        businessAreaId: item.businessAreaId
      }))
    };
  };

  const handleGenerateReport = async () => {
    try {
      const payload = buildPayload();
      await generateCommissionReport(payload)
      handleClose()
      console.log("Final API Payload:", payload);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const isSingle = form.businessType?.value === BUSINESS_TYPES.SINGLE;

  const handleClose = () => {
    setForm(EMPTY_GENERATE_REPORT_FORM)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
    >
      <div className="d-flex justify-content-betwen align-items-center">
        <div className="large-text color-dark ml-4 mt-3">
          Generate Commission Report
        </div>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent>
        <div className="regular-large-bold color-dark">
          Select Date Range
        </div>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <CustomDatePickerV2
              label="Start Date"
              value={form.startDate}
              handler={(i, date) => updateForm("startDate", date)}
              placeHolder="Select date"
              maxDate={
                form?.endDate
                  ? new Date(Math.min(new Date(), new Date(form.endDate)))
                  : new Date()
              }
            />
          </Grid>

          <Grid item xs={6}>
            <CustomDatePickerV2
              label="End Date"
              value={form.endDate}
              handler={(i, date) => updateForm("endDate", date)}
              placeHolder="Select date"
              minDate={form?.startDate}
              maxDate={new Date()}
            />
          </Grid>
        </Grid>

        <div className="color-dark regular-large-bold">
          Business Area Type
        </div>

        <RadioGroup
          row
          value={form.businessType?.label || ""}
          onChange={handleBusinessTypeChange}
        >
          <FormControlLabel
            value={BUSINESS_TYPES.FRANCHISE}
            control={<Radio />}
            label="Franchise (Non Flip)"
            disabled={!isBulkAccess}
          />

          <FormControlLabel
            value={BUSINESS_TYPES.SUB_CONTRACTOR}
            control={<Radio />}
            label="Sub-Contractor (Flip)"
            disabled={!isBulkAccess}
          />

          <FormControlLabel
            value={BUSINESS_TYPES.SINGLE}
            control={<Radio />}
            label="Single Business Area"
            disabled={!isBulkAccess && !isCreateAccess}
          />
        </RadioGroup>

        {form.businessType && !isSingle && (
          <>
            <div className="color-dark regular-large-bold">
              Subtype (Single Selection)
            </div>

            <RadioGroup
              value={form.subtype}
              onChange={handleSubtypeChange}
            >
              <Grid container spacing={2}>
                {subtypeOptions.map((sub) => (
                  <Grid item xs={4} key={sub.value}>
                    <FormControlLabel
                      value={sub.value}
                      control={<Radio />}
                      label={sub.label}
                    />
                  </Grid>
                ))}
              </Grid>
            </RadioGroup>
          </>
        )}

        {isSingle && (
          <>
            <div className="color-dark regular-large-bold">
              Single Business Area
            </div>

            <AAutoComplete
              currentValue={form?.businessArea ? form?.businessArea?.[0] : null}
              handleChange={(value) => updateForm("businessArea", [value])}
              items={businessAreas}
              isMulti={false}
              style={{ control: { height: "45px", borderRadius: "5px" } }}
            />
          </>
        )}

        <div className="mt-4">
          <AButton
            variant="primary_filled"
            onClick={handleGenerateReport}
            disabled={isGenerateDisabled}
            className="btn-left-0"
          >
            Generate Report
          </AButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GenerateCommissionDialog;
